export const debounceDelay = 250;
export const sendThrottleInterval = 1000;
export const MessageLengthLimit = 3500;
export const MessageLengthWarning = 3400;
